<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SkistarAccommodationText',
  computed: {
    ...mapState({
      accommodation: state => state.skistar.accommodation.selected,
      show: state => state.skistar.accommodation.texts.show,
      loading: state => state.skistar.accommodation.texts.itemsLoading,
      texts: state => state.skistar.accommodation.texts.items,
    }),
  },
  methods: {
    ...mapActions({
      close: 'skistar/closeAccommodationTexts',
    }),
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="show"
        @input="close"
        width="800"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <v-card-title class="modal-title">
                {{ accommodation.name }}, {{ accommodation.description}}
              </v-card-title>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  @click="close"
                  color="red darken-1"
                 flat
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-progress-linear
              v-if="loading"
              indeterminate
            >
            </v-progress-linear>
            <template v-else-if="texts.length === 0">
              No texts available
            </template>
            <template v-else>
              <div
                v-for="(text, index) in texts"
                :key="index"
                class="py-2"
              >
                <v-layout class="grey--text">
                  <v-flex xs6>
                    {{ text.language }}
                  </v-flex>
                  <v-flex
                      v-if="text.from !== '1753-01-01' && text.to !== '9999-12-31'"
                      class="text-xs-right"
                      xs6
                  >
                    ({{ text.from }} - {{ text.to }})
                  </v-flex>
                </v-layout>
                <span v-html="text.text"/>
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .modal-title {
    font-size: $font-size-md;
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationText.vue